import { render, staticRenderFns } from "./ProductType.vue?vue&type=template&id=6019b8ea&scoped=true&"
import script from "./ProductType.vue?vue&type=script&lang=js&"
export * from "./ProductType.vue?vue&type=script&lang=js&"
import style0 from "./ProductType.vue?vue&type=style&index=0&id=6019b8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6019b8ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6019b8ea')) {
      api.createRecord('6019b8ea', component.options)
    } else {
      api.reload('6019b8ea', component.options)
    }
    module.hot.accept("./ProductType.vue?vue&type=template&id=6019b8ea&scoped=true&", function () {
      api.rerender('6019b8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/ProductType.vue"
export default component.exports